import type { IResponsiveImageSrc } from './index';

export const createPromoImg = (basePath: string) => (name: string) =>
  `${basePath}/${name}.webp`;

export const createPromoStage = (basePath: string) => {
  const getImg = createPromoImg(basePath);

  return (
    stage: number
  ): { bg: IResponsiveImageSrc; characterImage: IResponsiveImageSrc } => ({
    bg: {
      desk: getImg(`bg_${stage}_desk`),
      mob: getImg(`bg_${stage}_mob`),
    },
    characterImage: {
      desk: getImg(`character_${stage}`),
      mob: getImg(`character_${stage}_mob`),
    },
  });
};

export const createPromoLevelImages = (
  basePath: string,
  glowColor: string,
  glowEndOpacity: number
) => {
  const getImg = createPromoImg(basePath);

  return (level: number) => ({
    image: getImg(`lvl_${level}`),
    lockedImage: getImg(`lvl_${level}`),
    glowColor,
    glowEndOpacity,
  });
};
